import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { ReelController } from "@lib/titan2-slingo/dist/game/controller/ReelController";
import { TweenConstants } from "@lib/titan2-slingo/dist/game/view/abstract/constant/TweenConstants";
import { AppEvent, GameErrorEvent } from "@lib/titan2/dist/game/Constants";
import { GameEvent } from "./event/GameEvent";
import { GameSoundEvent } from "./event/GameSoundEvent";
/**
 * GameReelController.ts
 */
export class GameReelController extends ReelController {
    addEventListeners() {
        super.addEventListeners();
        this.registerCore(GameErrorEvent.WAGER_BONUS, this.handleWagerError);
        this.registerCore(GameErrorEvent.WAGER_CASH, this.handleWagerError);
        this.registerGame(GameEvent.AWARD_FREE_SPINS, this.handleFreeSpins);
    }
    handleReelStopped() {
        if (this.reelDisplayData.getStopIndex() !== undefined) {
            // Check whether to increment the scatter count.
            if (this.reelDisplayData.getStopSymbol().isBonus()) {
                this.model.setScatterCount(this.model.getScatterCount() + 1);
            }
            // Handle dispatching events for this reel stop.
            this.handleReelSymbol(this.reelDisplayData.getStopIndex(), this.reelDisplayData.getStopSymbol());
            // Increment the stop index for the next stop.
            this.model.getReelDisplayData().stopReel();
            if (this.model.getReelDisplayData().isStopComplete()) {
                // The spin is complete, so handle awards.
                this.handleReelAwards();
            }
            else {
                // The spin is still in progress, so stop again after a delay.
                this.callAfter(this.getNextReelStopDelay(), this.stopReel);
            }
        }
    }
    getNextReelStopDelay() {
        // Check for scatter suspense.
        const scatterThreshold = this.model.getScatterThreshold();
        if (scatterThreshold >= 0 && this.model.getScatterCount() >= scatterThreshold) {
            return TweenConstants.REEL_STOP_INTERVAL_SUSPENSE;
        }
        // Check for win line suspense.
        const winLine = this.model.getWinLine();
        if (winLine && this.model.hasWinLineSuspense(this.reelDisplayData.getStopIndex(), winLine)) {
            return TweenConstants.REEL_STOP_INTERVAL_SUSPENSE;
        }
        // Check for extra spins.
        if (this.model.getGameProgress().getSpinsRemaining() === 0) {
            return TweenConstants.REEL_STOP_INTERVAL_PURCHASE;
        }
        return TweenConstants.REEL_STOP_INTERVAL_STANDARD;
    }
    async handleReelAwards() {
        this.chanceGameDone = this.model.getScatterThreshold() < 0 || this.model.getScatterCount() <= this.model.getScatterThreshold();
        this.winLineDone = this.model.getWinLine() == null;
        super.handleReelAwards();
    }
    async handleFreeSpins() {
        const hasFreeSpinsToAward = this.model.getSpinResult().getReelSequence().getFreeSpinIndexes().length > 0;
        if (hasFreeSpinsToAward) {
            await new Promise(resolve => {
                // Resolve after all free spins have been awarded.
                this.registerGame(SlingoEvent.FREE_SPIN_AWARD_COMPLETE, function handler() {
                    this.unregisterGame(SlingoEvent.FREE_SPIN_AWARD_COMPLETE, handler);
                    resolve();
                });
                super.handleFreeSpins();
            });
        }
    }
    handleFreesSpinAwardComplete() {
        this._freeSpinsDone = true;
    }
    async determineReelsAwardBehaviour() {
        if (!this.chanceGameDone) {
            this.dispatchGame(GameSoundEvent.SCATTER_SYMBOL_WIN);
            await new Promise(resolve => this.callAfter(1000, resolve));
            await this.dispatchBlockingEvent(GameEvent.SCATTER_WIN_SUSPENSE_STOP);
            this.dispatchGame(GameEvent.SCATTER_WIN_COLLECT);
            await new Promise(resolve => this.callAfter(1000, resolve));
            await this.dispatchBlockingEvent(SlingoEvent.SCATTER_WIN_ANIMATION);
            this.chanceGameDone = true;
        }
        else {
            await this.dispatchBlockingEvent(GameEvent.SCATTER_WIN_SUSPENSE_CANCELLED);
        }
        if (!this.winLineDone) {
            await new Promise(resolve => this.callAfter(2000, resolve));
            await this.dispatchBlockingEvent(GameEvent.WIN_LINE_ANIMATION);
            this.winLineDone = true;
        }
        this.dispatchGame(GameEvent.WILD_PARTICLE_FEATURE_COMPLETE);
        this.dispatchGame(SlingoEvent.REELS_COMPLETE);
    }
    async handleSpinResult() {
        await this.waitForError;
        super.handleSpinResult();
    }
    handleWagerError() {
        this.waitForError = new Promise(resolve => this.registerGame(AppEvent.ERROR_COMPLETE, function handler() {
            this.unregisterGame(AppEvent.ERROR_COMPLETE, handler);
            resolve();
        }));
    }
    handleRecovery() {
        super.handleRecovery();
        let spin = this.model.getSpinResult();
        if (spin) {
            this.dispatchGame(GameEvent.RECOVER_REEL_SYMBOLS);
        }
    }
}
//# sourceMappingURL=GameReelController.js.map